module.exports = __webpack_public_path__ + "testimonialsflowers_trim.png?e60f285095a403aa888a49d0259e7931";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/general/testimonialsflowers_trim.png
// module id = 188
// module chunks = 0